<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="container mainContent">
<mat-expansion-panel expanded="false" id="headerContent">
  <mat-expansion-panel-header>
    <h1 id="title">{{translation.WheelNewsOrder}}</h1>
  </mat-expansion-panel-header>
  <div id="clientContent">
    <div id="addressContent">
      <mat-card>
        <div class="line">
          <p>{{translation.Client + ':'}}</p>
          <p>{{order.Client.Name}}</p>
        </div>
        <div class="line">
          <p>{{translation.Contact + ':'}}</p>
          <p>{{order.Client.Contact}}</p>
        </div>
        <div class="line">
          <p>{{translation.Email + ':'}}</p>
          <p>{{order.Client.Email}}</p>
        </div>
        <div class="line">
          <p>{{translation.Phone + ':'}}</p>
          <p>{{order.Client.Phone}}</p>
        </div>
        <div class="line">
          <p>{{translation.AddressLine1 + ':'}}</p>
          <p>{{order.Client.AddressLine1}}</p>
        </div>
        <div class="line" *ngIf="order.Client.AddressLine2 != ''">
          <p>{{translation.AddressLine2 + ':'}}</p>
          <p>{{order.Client.AddressLine2}}</p>
        </div>
        <div class="line">
          <p>{{translation.ZipAndCity + ':'}}</p>
          <p>{{order.Client.Zip + ' ' + order.Client.City + ' (' + order.Client.Region + ')'}}</p>
        </div>
      </mat-card>
    </div>
    <div id="logoContent">
      <img src="../../../../assets/logos/wheelnews_RGB_pos.svg" alt="CotraLogo" id="logo"/>
    </div>
  </div>
</mat-expansion-panel>
<form>
<mat-stepper orientation="horizontal" #stepper id="stepper" selectedIndex="{{this.stepper.selectedIndex}}">
<mat-step state="number">
  <ng-template matStepLabel>{{translation.Sender}}</ng-template>
  <mat-card class="formCard">
    <div class="headerContent">
      <mat-radio-group name="senderRadioButtonGroup" class="addressRadioButtonContent">
        <mat-radio-button class="addressRadioButton" name="senderFreeDataRadio" color="primary" value="0" (change)="senderChangeToFreeData()" checked="{{senderIsFreeData}}">{{translation.FreeText}}</mat-radio-button>
        <mat-radio-button class="addressRadioButton" name="senderSelfDataRadio" color="primary" value="1" (change)="senderChangeToSelfData()" checked="{{!senderIsFreeData}}">{{translation.OwnAddress}}</mat-radio-button>
        <mat-radio-button class="addressRadioButton" name="senderNoDataRadio" color="primary" value="2" (change)="willBeBroughtByCustomerRadioChange()" checked="{{order.WillBeBroughtByCustomer}}">{{translation.IsBroughtByCustomer}}</mat-radio-button>
      </mat-radio-group>
      <div class="buttonContent">
        <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
      </div>
    </div>
    <div class="inputContent">
      <mat-form-field class="fieldForm">
        <input name="senderName" matInput placeholder="{{translation.Sender}}" [(ngModel)]="order.Sender.Name" required disabled="{{disabledSenderFields1}}" maxlength="100">
      </mat-form-field>
      <div class="customLine">
        <mat-form-field class="fieldForm">
          <input name="senderContact" matInput placeholder="{{translation.Contact}}" [(ngModel)]="order.Sender.Contact" required disabled="{{disabledSenderFields2}}" maxlength="200">
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <mat-select [(ngModel)]="order.Sender.NotificationText" name="senderNotification" placeholder="{{translation.Notification}}" disabled="{{disabledSenderFields3}}" required>
            <mat-option *ngFor="let notification of notifications" [value]="notification.value" disabled="{{disabledSenderFields3}}">{{notification.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field class="fieldForm">
        <input name="senderEmail" matInput placeholder="{{translation.Email}}" [(ngModel)]="order.Sender.Email" required disabled="{{disabledSenderFields2}}" maxlength="100">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="senderPhone" matInput placeholder="{{translation.Phone}}" [(ngModel)]="order.Sender.Phone" required disabled="{{disabledSenderFields2}}" maxlength="30">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="senderAddressLine1" matInput placeholder="{{translation.AddressLine1}}" [(ngModel)]="order.Sender.AddressLine1" required disabled="{{disabledSenderFields1}}" maxlength="50">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="senderAddressLine2" matInput placeholder="{{translation.AddressLine2}}" [(ngModel)]="order.Sender.AddressLine2" disabled="{{disabledSenderFields1}}" maxlength="50">
      </mat-form-field>
      <div class="customLine">
        <mat-form-field class="fieldForm" *ngIf="senderIsFreeData" [floatLabel]="senderFloatLabelControl.value">
          <input type="text" name="senderSearch" placeholder="{{translation.City}} {{translation.Or}} {{translation.Zip}}" matInput [formControl]="autoCompleteSenderSearch" [matAutocomplete]="autoSenderSearch" [(ngModel)]="senderSearchText">
          <mat-autocomplete #autoSenderSearch="matAutocomplete">
            <mat-option *ngFor="let senderSearch of filteredSenderSearchList | async" (onSelectionChange)="onSenderSearch($event, senderSearch)" [value]="">{{senderSearch.City}} ({{senderSearch.Zip}})</mat-option>
          </mat-autocomplete>
          <mat-label><mat-icon>search</mat-icon>&nbsp;{{translation.Search}}</mat-label>
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <input name="senderZip" matInput placeholder="{{translation.Zip}}" [(ngModel)]="order.Sender.Zip" required disabled="{{disabledSenderFields1}}" maxlength="10">
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <input name="senderCity" matInput placeholder="{{translation.City}}" [(ngModel)]="order.Sender.City" required disabled="{{disabledSenderFields1}}" maxlength="50">
        </mat-form-field>
      </div>
      <mat-form-field class="fieldForm">
        <input name="senderDate" matInput [matDatepicker]="picker" placeholder="{{this.order.Sender.Selection === 2 ? translation.BringDate : translation.ReadyForCollection}}" [(ngModel)]="tempDate" [min]="minDate" (focus)="openDatePicker(picker)" (click)="openDatePicker(picker)" required #elementToFocus>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <textarea name="senderComment" matInput placeholder="{{translation.Comment}}" [(ngModel)]="order.Sender.Comment" rows="4" maxlength="500"></textarea>
      </mat-form-field>
      <mat-radio-group name="senderFooterRadioButtonGroup" class="addressRadioButtonContent">
        <mat-radio-button class="addressRadioButton" name="sameRecipientAddress" color="primary" value="0" checked="{{!differentRecipientAddress}}" (change)="sameRecipientAddressRadioChange()" disabled="{{disabledSenderFields4}}">{{translation.RecipientSameAsSender}}</mat-radio-button>
        <mat-radio-button class="addressRadioButton" name="differentRecipientAddress" color="primary" value="1" checked="{{differentRecipientAddress}}" (change)="differentRecipientAddressRadioChange()">{{translation.DifferentRecipientAddress}}</mat-radio-button>
        <mat-radio-button class="addressRadioButton" name="willBePickedUpByCustomer" color="primary" value="2" checked="{{order.WillBePickedUpByCustomer}}" (change)="willBePickedUpByCustomerRadioChange()">{{translation.IsPickedUpByCustomer}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="footerContent">
      <div class="buttonContent">
        <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
      </div>
    </div>
  </mat-card>
</mat-step>
<mat-step state="number">
  <ng-template matStepLabel>{{translation.Recipient}}</ng-template>
  <mat-card class="formCard">
    <div class="headerContent">
      <mat-radio-group name="recipientRadioButtonGroup" class="addressRadioButtonContent">
        <mat-radio-button class="addressRadioButton" name="recipientFreeDataRadio" color="primary" value="0" (change)="recipientChangeToFreeData()" checked="{{recipientIsFreeData}}">{{translation.FreeText}}</mat-radio-button>
        <mat-radio-button class="addressRadioButton" name="recipientSelfDataRadio" color="primary" value="1" (change)="recipientChangeToSelfData()" checked="{{!recipientIsFreeData}}">{{translation.OwnAddress}}</mat-radio-button>
      </mat-radio-group>
      <div class="buttonContent">
        <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
        <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
      </div>
    </div>
    <div class="inputContent">
      <mat-form-field class="fieldForm">
        <input name="recipientName" matInput placeholder="{{translation.Recipient}}" [(ngModel)]="order.Recipient.Name" required disabled="{{disabledRecipientFields1}}" maxlength="100">
      </mat-form-field>
      <div class="customLine">
        <mat-form-field class="fieldForm">
          <input name="recipientContact" matInput placeholder="{{translation.Contact}}" [(ngModel)]="order.Recipient.Contact" required disabled="{{disabledRecipientFields2}}" maxlength="200">
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <mat-label>{{translation.Notification}}</mat-label>
          <mat-select name="recipientNotification" required [(ngModel)]="order.Recipient.NotificationText">
            <mat-option *ngFor="let notification of notifications" [value]="notification.value">{{notification.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <mat-form-field class="fieldForm">
        <input name="recipientEmail" matInput placeholder="{{translation.Email}}" [(ngModel)]="order.Recipient.Email" required disabled="{{disabledRecipientFields2}}" maxlength="100">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="recipientPhone" matInput placeholder="{{translation.Phone}}" [(ngModel)]="order.Recipient.Phone" required disabled="{{disabledRecipientFields2}}" maxlength="30">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="recipientAddressLine1" matInput placeholder="{{translation.AddressLine1}}" [(ngModel)]="order.Recipient.AddressLine1" required disabled="{{disabledRecipientFields1}}" maxlength="50">
      </mat-form-field>
      <mat-form-field class="fieldForm">
        <input name="recipientAddressLine2" matInput placeholder="{{translation.AddressLine2}}" [(ngModel)]="order.Recipient.AddressLine2" disabled="{{disabledRecipientFields1}}" maxlength="50">
      </mat-form-field>
      <div class="customLine">
        <mat-form-field class="fieldForm" *ngIf="recipientIsFreeData" [floatLabel]="recipientFloatLabelControl.value">
          <input type="text" name="recipientSearch" placeholder="{{translation.City}} {{translation.Or}} {{translation.Zip}}" matInput [formControl]="autoCompleteRecipientSearch" [matAutocomplete]="autoRecipientSearch" [(ngModel)]="recipientSearchText">
          <mat-autocomplete #autoRecipientSearch="matAutocomplete">
            <mat-option *ngFor="let recipientSearch of filteredRecipientSearchList | async" (onSelectionChange)="onRecipientSearch($event, recipientSearch)" [value]="">{{recipientSearch.City}} ({{recipientSearch.Zip}})</mat-option>
          </mat-autocomplete>
          <mat-label><mat-icon>search</mat-icon>&nbsp;{{translation.Search}}</mat-label>
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <input name="recipientZip" matInput placeholder="{{translation.Zip}}" [(ngModel)]="order.Recipient.Zip" required disabled="{{disabledRecipientFields1}}" maxlength="10">
        </mat-form-field>
        <mat-form-field class="fieldForm">
          <input name="recipientCity" matInput placeholder="{{translation.City}}" [(ngModel)]="order.Recipient.City" required disabled="{{disabledRecipientFields1}}" maxlength="50">
        </mat-form-field>
      </div>
      <mat-form-field class="fieldForm">
        <textarea name="recipientComment" matInput placeholder="{{translation.Comment}}" [(ngModel)]="order.Recipient.Comment" rows="4" maxlength="500"></textarea>
      </mat-form-field>
    </div>
    <div class="footerContent">
      <div class="buttonContent">
        <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
        <button type="button" mat-button (click)="validate()">{{translation.Next}}</button>
      </div>
    </div>
  </mat-card>
</mat-step>
<mat-step state="number">
  <ng-template matStepLabel>{{translation.Rims}}</ng-template>
  <mat-card class="formCard">
    <div class="headerContent">
      <button mat-mini-fab class="rimButton green" (click)="addRimset()" matTooltip="{{translation.AddAdditionalRim}}" matTooltipShowDelay="500">
        <span class="material-icons">add</span>
      </button>
      <button mat-mini-fab class="rimButton red" [disabled]="tabs.length === 1" (click)="removeRimset()" matTooltip="{{translation.DeleteThisRim}}" matTooltipShowDelay="500">
        <mat-icon>delete</mat-icon>
      </button>
      <div class="buttonContent">
        <button type="button" mat-button (click)="back()" [disabled]="inProgress">{{translation.Back}}</button>
        <button type="button" mat-button (click)="validate()" [disabled]="inProgress">{{translation.Next}}</button>
      </div>
    </div>
    <div class="inputContent">
      <mat-tab-group [selectedIndex]="selectedRimset.value" (selectedIndexChange)="selectedRimsetIndexChange($event)">
        <mat-tab *ngFor="let tab of tabs; let index = index" [label]="tab">
          <div class="listContent">
            <mat-form-field class="fieldForm">
              <mat-label>{{translation.RimAmount}}</mat-label>
              <mat-select name="rimAmount" required [(ngModel)]="order.RimsetList[selectedRimset.value].RimAmount">
                <mat-option *ngFor="let rimAmount of rimAmountList" [value]="rimAmount">{{rimAmount}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="commissionNumber" matInput placeholder="{{translation.CommissionNumber}}" [(ngModel)]="order.RimsetList[selectedRimset.value].CommissionNumber" required maxlength="1000">
            </mat-form-field>
            <mat-form-field class="fieldForm">
              <input name="sparePartNumber" matInput placeholder="{{translation.SparePartNumber}}" [(ngModel)]="order.RimsetList[selectedRimset.value].SparePartNumber" maxlength="1000">
            </mat-form-field>
            <label class="checkboxLabel">{{translation.OrderArt}} *</label>
            <div class="checkboxContent">
              <label>{{translation.Repair}}</label>
              <mat-checkbox
                *ngFor="let orderType of order.RimsetList[selectedRimset.value].OrderTypes"
                [checked]="orderType.Selected"
                (change)="specialCheckboxChange($event, orderType)"
                color="primary"
                class="orderTypeCheckBox">
                {{orderType.Value}}
              </mat-checkbox>
              <mat-form-field class="fieldForm" *ngIf="order.RimsetList[selectedRimset.value].DamageCommentTextActive">
                <textarea name="damageComment" matInput placeholder="{{translation.PleaseDescribeDamageType}}" [(ngModel)]="order.RimsetList[selectedRimset.value].DamageComment" rows="4" required maxlength="850"></textarea>
              </mat-form-field>
              <label>{{translation.Repaint}}</label>
              <mat-checkbox
                [checked]="order.RimsetList[selectedRimset.value].Repaint.Selected"
                (change)="specialCheckboxChange($event, order.RimsetList[selectedRimset.value].Repaint)"
                color="primary"
                class="orderTypeCheckBox">
                {{order.RimsetList[selectedRimset.value].Repaint.Value}}
              </mat-checkbox>
              <mat-form-field class="fieldForm" *ngIf="order.RimsetList[selectedRimset.value].RepaintCommentTextActive">
                <textarea name="repaintComment" matInput placeholder="{{translation.PleaseDescribeRepaint}}" [(ngModel)]="order.RimsetList[selectedRimset.value].RepaintComment" rows="4" required maxlength="850"></textarea>
              </mat-form-field>
            </div>
            <mat-form-field class="fieldForm">
              <textarea name="comment" matInput placeholder="{{translation.Comment}}" [(ngModel)]="order.RimsetList[selectedRimset.value].Comment" rows="4" maxlength="850"></textarea>
            </mat-form-field>
          </div>
          <div id="uploadContent" appDnd class="row dropZone" (fileDropped)="onFileDropped($event)">
            <input type="file" #fileDropRef id="fileDropRef" multiple (change)="fileBrowserHandler($event.target.files)">
            <img src="../../../../assets/images/uploadFile.svg" alt="uploadFile">
            <h4>{{translation.DragAndDropFileHere}}</h4>
            <h4>{{translation.Or}}</h4>
            <label id="fileDropButton" class="mat-button" for="fileDropRef">{{translation.BrowseForFile}}</label>
          </div>
          <div class="files-list">
            <div class="single-file" *ngFor="let file of files; let i = index">
              <img src="../../../../assets/images/file.svg" width="45px" alt="file">
              <div class="info">
                <h4 class="name">{{file?.name}}</h4>
                <p class="size">{{formatBytes(file?.size)}}</p>
                <app-progress [progress]="file?.progress"></app-progress>
              </div>
              <img src="../../../../assets/images/deleteFile.svg" class="delete" width="20px" alt="file" (click)="deleteFile(i)">
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <div class="footerContent">
      <div class="buttonContent">
        <button type="button" mat-button (click)="back()" [disabled]="inProgress">{{translation.Back}}</button>
        <button type="button" mat-button (click)="validate()" [disabled]="inProgress">{{translation.Next}}</button>
      </div>
    </div>
  </mat-card>
</mat-step>
<mat-step state="number">
  <div class="siteMargin">
    <ng-template matStepLabel>{{translation.Confirm}}</ng-template>
    <div class="summaryCards">
      <mat-card class="summaryCard">
        <mat-card-content class="summaryCardContent">
          <mat-card-title class="summaryCardTitle">{{translation.Client}}</mat-card-title>
          <mat-card-subtitle class="addressLine">{{order.Client.Name}}</mat-card-subtitle>
          <mat-card-subtitle class="addressLine">{{order.Client.AddressLine1}}</mat-card-subtitle>
          <mat-card-subtitle class="addressLine" *ngIf="order.Client.AddressLine2 != ''">{{order.Client.AddressLine2}}</mat-card-subtitle>
          <mat-card-subtitle class="addressLine">{{order.Client.Zip}} {{order.Client.City}}</mat-card-subtitle>
          <mat-card-subtitle class="lastLine">
            <mat-radio-group name="freightPayerRadioGroup">
              <mat-radio-button class="matRadioButtonCustom" #clientRadio name="clientRadio" value="0" (change)="changeFreightPayer(0)" color="primary" checked>{{translation.FreightPayer}}</mat-radio-button>
            </mat-radio-group>
          </mat-card-subtitle>
          <mat-card-subtitle *ngIf="order.FreightPayerSelection === 0">
            <mat-label>{{translation.ChoosePartner}}</mat-label>
            <mat-select [(value)]="selectedAid">
              <mat-option *ngFor="let partner of partnerList" [value]="partner">{{partner}}</mat-option>
            </mat-select>
          </mat-card-subtitle>
        </mat-card-content>
      </mat-card>
      <mat-card class="summaryCard middleCard">
        <mat-card-content class="summaryCardContent">
          <mat-card-title class="summaryCardTitle">{{translation.Sender}}</mat-card-title>
          <mat-card-subtitle *ngIf="order.Sender.Selection === 2" class="addressLine">{{translation.IsBroughtByCustomer}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="order.Sender.Selection != 2" class="addressLine">{{order.Sender.Name}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="order.Sender.Selection != 2" class="addressLine">{{order.Sender.AddressLine1}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="order.Sender.Selection != 2 && order.Sender.AddressLine2 != ''" class="addressLine">{{order.Sender.AddressLine2}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="order.Sender.Selection != 2" class="addressLine">{{order.Sender.Zip}} {{order.Sender.City}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="tempDate != null" class="addressLine">{{this.order.Sender.Selection === 2 ? translation.BringDate : translation.ReadyForCollection}}: {{this.tempDate | date: 'dd.MM.yyyy'}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!senderIsFreeData" class="lastLine"></mat-card-subtitle>
        </mat-card-content>
      </mat-card>
      <mat-card class="summaryCard">
        <mat-card-content class="summaryCardContent">
          <mat-card-title class="summaryCardTitle">{{translation.Recipient}}</mat-card-title>
          <mat-card-subtitle *ngIf="order.WillBePickedUpByCustomer" class="addressLine">{{translation.IsPickedUpByCustomer}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!order.WillBePickedUpByCustomer" class="addressLine">{{order.Recipient.Name}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!order.WillBePickedUpByCustomer" class="addressLine">{{order.Recipient.AddressLine1}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!order.WillBePickedUpByCustomer && order.Recipient.AddressLine2 != ''" class="addressLine">{{order.Recipient.AddressLine2}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!order.WillBePickedUpByCustomer" class="addressLine">{{order.Recipient.Zip}} {{order.Recipient.City}}</mat-card-subtitle>
          <mat-card-subtitle *ngIf="!recipientIsFreeData" class="lastLine">
          </mat-card-subtitle>
        </mat-card-content>
      </mat-card>
    </div>
    <mat-card id="rimCard">
      <mat-card-content class="rimCardContent">
        <mat-card-title class="summaryCardTitle">{{translation.Rims}}</mat-card-title>
        <div id="rimHeaderRow">
          <div class="rimRowItem">{{translation.RimAmount}}</div>
          <div class="rimRowItem">{{translation.Comment}}</div>
          <div class="rimRowItem rimRowHeaderItem">{{translation.DamageType}}</div>
        </div>
        <mat-card-subtitle *ngFor="let rimset of order.RimsetList">
          <div class="rimRow">
            <div class="rimRowItem">{{rimset.RimAmount}}</div>
            <div class="rimRowItem" *ngIf="rimset.Comment != '' && rimset.Comment != null">{{rimset.Comment}}</div>
            <div class="rimRowItem" *ngIf="rimset.Comment == '' || rimset.Comment == null">{{translation.None}}</div>
            <div class="rimRowItemColumnStyle">
              <div *ngFor="let specialSelect of rimset.OrderTypes">
                <div *ngIf="specialSelect.Selected && specialSelect.Key != 99">-&nbsp;{{specialSelect.Value}}</div>
              </div>
              <div *ngIf="rimset.DamageCommentTextActive">-&nbsp;{{rimset.DamageComment}}</div>
              <div *ngIf="rimset.RepaintCommentTextActive">- {{rimset.RepaintComment}}</div>
            </div>
          </div>
        </mat-card-subtitle>
      </mat-card-content>
    </mat-card>
    <mat-card id="additionalInformationCard">
      <mat-card-content class="rimCardContent">
        <mat-card-title class="summaryCardTitle">{{translation.DeliveryOptions}}</mat-card-title>
        <mat-radio-group name="deliveryOptionsRadioGroup" id="deliveryOptionsRadioGroup">
          <mat-radio-button class="matRadioButtonCustom" name="standardRadio" value="0" (change)="changeDeliveryOptions(0, '')" color="primary" checked>{{translation.Standard2}}</mat-radio-button>
          <mat-radio-button class="matRadioButtonCustom" name="expressTwoRadio" value="1" (change)="changeDeliveryOptions(1, translation.Express)" color="primary">{{translation.Express1}}</mat-radio-button>
          <p class="expressDetail">{{translation.Express3Detail2}}</p>
          <p class="expressDetail">{{translation.Express3Detail3}}</p>
        </mat-radio-group>
      </mat-card-content>
    </mat-card>
    <div class="lastFooterContent">
      <div class="buttonContent">
        <button type="button" mat-button (click)="back()">{{translation.Back}}</button>
        <button (click)="send()" type="submit" mat-button class="customButton">{{translation.Send}}</button>
      </div>
    </div>
  </div>
</mat-step>
</mat-stepper>
</form>
</div>
<app-footer></app-footer>
